var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoTelavita(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 109.05,
    height: 21.891,
    viewBox: "0 0 109.05 21.891",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Logo_Telavita",
    "data-name": "Logo Telavita",
    transform: "translate(-520.661 -1316.319)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2407",
    "data-name": "Caminho 2407",
    d: "M1184.74,1352.686a4.244,4.244,0,0,1-1.8.457,1.863,1.863,0,0,1-1.948-2.13v-6.482h4.17v-3.2h-4.139v-3.865h-3.713v3.865h-2.8v3.2h2.8v6.482c0,3.743,2.13,5.6,5.387,5.478a8.3,8.3,0,0,0,3.074-.639Z",
    transform: "translate(-573.658 -18.557)",
    fill: "#1F35B5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2408",
    "data-name": "Caminho 2408",
    d: "M646.577,1365.009c-4.869,0-7.974,3.287-7.974,7.852,0,4.809,3.074,8,8.247,8a9.215,9.215,0,0,0,6.452-2.435l-2.374-2.344a6.191,6.191,0,0,1-4.017,1.4c-2.617,0-4.23-1.339-4.474-3.2h11.717C654.733,1368.113,651.6,1365.009,646.577,1365.009Zm-4.078,6.208a4.041,4.041,0,0,1,4.2-2.922c2.13,0,3.652.974,3.9,2.922Z",
    transform: "translate(-103.476 -42.718)",
    fill: "#1F35B5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_598",
    "data-name": "Ret\\xE2ngulo 598",
    width: 3.682,
    height: 21.432,
    transform: "translate(552.667 1316.319)",
    fill: "#1F35B5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2409",
    "data-name": "Caminho 2409",
    d: "M839.9,1368.187a5.507,5.507,0,0,0-4.778-2.435c-4.382-.031-7.821,2.678-7.821,7.852,0,5.265,3.287,8,7.73,7.974,1.674-.031,4.017-.883,4.869-2.648l.183,2.191h3.5v-15H840.02Zm-4.443,9.982a4.551,4.551,0,0,1,0-9.1C841.3,1369.069,841.3,1378.169,835.455,1378.169Z",
    transform: "translate(-269.029 -43.37)",
    fill: "#1F35B5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2410",
    "data-name": "Caminho 2410",
    d: "M1289.741,1366.117l-.122,2.069a5.508,5.508,0,0,0-4.778-2.435c-4.382-.031-7.821,2.678-7.821,7.852,0,5.265,3.287,8,7.73,7.974,1.674-.031,4.017-.883,4.869-2.648l.183,2.191h3.5v-15Zm-4.565,12.051a4.551,4.551,0,0,1,0-9.1C1291.019,1369.069,1291.019,1378.169,1285.176,1378.169Z",
    transform: "translate(-663.591 -43.37)",
    fill: "#1F35B5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2411",
    "data-name": "Caminho 2411",
    d: "M984.138,1378.915l-4.382-10.432h-4.048l6.421,15.095h4.017l6.391-15.095H988.49Z",
    transform: "translate(-399.235 -45.766)",
    fill: "#1F35B5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_599",
    "data-name": "Ret\\xE2ngulo 599",
    width: 3.713,
    height: 15.064,
    transform: "translate(595.223 1322.687)",
    fill: "#1F35B5"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Agrupar_826",
    "data-name": "Agrupar 826",
    transform: "translate(520.661 1316.319)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2412",
    "data-name": "Caminho 2412",
    d: "M531.374,1321.573a5.357,5.357,0,0,0-5.354-5.254h-5.359v5.358h5.358v16.074h5.358v-16.177Z",
    transform: "translate(-520.661 -1316.319)",
    fill: "#1F35B5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2413",
    "data-name": "Caminho 2413",
    d: "M613.388,1321.677h0v-5.358h-5.358A5.358,5.358,0,0,0,613.388,1321.677Z",
    transform: "translate(-597.316 -1316.319)",
    fill: "#1F35B5"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoTelavita);
export default __webpack_public_path__ + "static/media/logo-telavita.c951eeb1.svg";
export { ForwardRef as ReactComponent };